import React, { useEffect, useId } from "react";
import Icon from "./Icon";

const TONES = {
  brand: "bg-qv-brand-50 text-qv-brand",
  danger: "bg-qv-red-50 text-qv-red",
};

// Confirmation centrée de la maquette (« Continuer sans facture ? », « Arrêter la
// recharge ? », « Débloquer le câble ? »). Les boutons sont passés en enfants,
// l'action principale en premier : empilés sur mobile (action principale en
// haut), côte à côte en version web (action principale à droite).
export default function Dialog({ open, onClose, icon, tone = "brand", title, text, children }) {
  const titleId = useId();

  useEffect(() => {
    if (!open) return undefined;
    const onKeyDown = (event) => {
      if (event.key === "Escape") onClose?.();
    };
    document.addEventListener("keydown", onKeyDown);
    return () => document.removeEventListener("keydown", onKeyDown);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center p-6 font-montserrat text-qv-ink md:p-10">
      <div className="absolute inset-0 bg-[rgba(25,25,25,.5)]" onClick={onClose} aria-hidden="true" />
      <div
        role="alertdialog"
        aria-modal="true"
        aria-labelledby={titleId}
        className="relative w-full max-w-[392px] rounded-2xl bg-white p-6 shadow-[0_20px_24px_-4px_rgba(10,13,18,.12)] md:max-w-[480px] md:p-8"
      >
        {icon && (
          <div className={`mb-4 h-12 w-12 rounded-full flex items-center justify-center ${TONES[tone]}`}>
            <Icon name={icon} size={24} />
          </div>
        )}
        <h2 id={titleId} className="mb-1.5 text-lg leading-7 font-bold md:text-xl">
          {title}
        </h2>
        {text && <p className="mb-6 text-sm leading-5 text-qv-muted">{text}</p>}
        <div className="flex flex-col gap-2.5 md:grid md:grid-cols-2 md:gap-3 md:[&>*:first-child]:order-2">
          {children}
        </div>
      </div>
    </div>
  );
}
